import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import calendar from "@/extension/h5/calendar"

addCustomWidgetSchema({
  type: 'calendar',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '日历',
    title: '预约日期',
    columnWidth: '200px',
    required: false,
    labelWidth: '110',
    labelHidden: true,
    labelAlign: 'label-right-align',
    futureDateDisabled: false, //禁用未来时间
    pastDateDisabled: true, //禁用过去时间
    // labelKey: 'dicValue',
    // valueKey: 'dicKey',
    placeholder: '',
    textAlign: "left",//文字对齐方式
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: '',
  }
})  //加载组件Json Schema

Vue.component(calendar.name, calendar)  //注册组件


PERegister.registerCPEditor('futureDateDisabled', 'futureDateDisabled-editor',
  PEFactory.createBooleanEditor('futureDateDisabled', '禁用未来日期'))

PERegister.registerCPEditor('pastDateDisabled', 'pastDateDisabled-editor',
  PEFactory.createBooleanEditor('pastDateDisabled', '禁用过去日期'))